<template>
  <!-- 最新文件详情页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党章党规</el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/index/dzdg' }">党章党规</el-breadcrumb-item> -->
          <el-breadcrumb-item>{{ $route.params.columnName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="dsxqy-cont">
        <ul class="dsxqy-cont-down">
          <li v-for="(item, index) in dnhdList" :key="index">
            <a :href="item.nodeUrl" target="_blank">{{ item.title }}</a>
            <span>{{ item.pubDate }}</span>
          </li>
        </ul>
      </div>
      <!--分页-->
      <div class="block">
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="toTal"
        >
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      dnhdList: [],
      currentPage: 1,
      pageSize: 10,
      toTal: 0,
    };
  },
  created() {
    this.getlatestFile()
  },
  methods: {
    getlatestFile(){
      this.axios({
        url: "data/cnki/getKbaseList",
        method: "post",
        data: {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          uid: this.$route.params.uid,
          sign:'更多'
        },
      }).then((res) => {
        this.dnhdList = res.data.rows
        this.toTal = res.data.total
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getlatestFile()
    },
  },
};
</script>

<style  lang="scss" scoped>
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
  }
  .dsxqy-cont {
    .dsxqy-cont-down {
      width: 1200px;
      height: 416px;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 16px 30px 0 30px;
      background: url("../assets/images/dnhd-dwbg.png") repeat-x;
      li {
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 40px;
        a {
          margin-left: 18px;
          &:hover{
            color: #BD1A2D;
          }
        }
      }
      li:before {
        position: absolute;
        top: 14px;
        content: "";
        display: inline-block;
        width: 8px;
        height: 12px;
        background: url("../assets/images/vector.png") no-repeat;
      }
      p {
        text-align: right;
        font-size: 16px;
        margin-top: 10px;
        a {
          color: #9f9fa6;
        }
      }
    }
  }
   :deep(.block) {
    margin-top: 40px;
    text-align: center;
  }
}
</style>